import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'fcp-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss']
})
export class SearchBoxComponent implements OnInit, OnDestroy {
  @Input() isBtnPrimary: boolean;

  @Output() public searchAction: EventEmitter<string> = new EventEmitter();
  @Output() public clearAction: EventEmitter<any> = new EventEmitter();

  private searchEvent = new Subject<any>();
  private searchEventSubscription: Subscription;
  public searchTerm = '';

  constructor() {}

  ngOnInit() {
    this.searchEventSubscription = this.searchEvent
      .pipe(debounceTime(400))
      .subscribe(() => {
        if (
          this.searchTerm &&
          this.searchTerm.length &&
          this.searchTerm.trim().length
        ) {
          this.searchAction.emit(this.searchTerm);
        }
      });
  }

  public clicked(): void {
    this.searchAction.emit(this.searchTerm);
  }

  public clearResults(): void {
    this.clearAction.emit();
  }

  public search(term) {
    this.searchEvent.next(term);
  }

  ngOnDestroy() {
    this.searchEventSubscription.unsubscribe();
  }
}
